import "../App.css";
//import "./home.css";
import React, { useState, useEffect } from "react";
import { LoadingPage } from "../loading/LoadingPage";
import { NavigationBar } from "../navigation/NavigationBar";

import { useParams, Link } from "react-router-dom";
import { call, home } from "../service/ApiService";
import {
  Container,
  List,
  Paper,
  //Grid,
  // Button,
  // AppBar,
  // Toolbar,
  //Typography,
  ListItem,
  ListItemText,
  InputBase,
  Checkbox,
  ListItemSecondaryAction,
  IconButton,
  Button,
} from "@mui/material";

export function API() {
  let subject = "관리자 페이지";
  let navigationBar = NavigationBar(subject);

  const [loading, setLoading] = useState(0);

  //<Checkbox checked={item.done} onChange={checkboxEventHandler} />

  useEffect(() => {
    //effect 훅 //랜더링 후에 수행 이후  []의 오브젝트가 변경되면 수행
    call("/admin/userList", "POST", "").then((response) => {
      //console.log(response);
      if (!response) {
        alert("권한 없음.");
        window.location.href = "/home";
        return;
      }
      if (response.error) {
        alert("누구냐 넌 : " + response.error);
        window.location.href = "/home";
        return;
      }
      if (response.data) {
        setLoading(1);
      }
    });
  }, []);

  let menu = (
    <Paper style={{ margin: 16 }}>
      <List className="menu">
        <div>{"Menu"}</div>
        <ListItem>
          <Link to="/home" variant="2">
            상위단계 home
          </Link>
          <ListItemText></ListItemText>
          <ListItemSecondaryAction>안녕하세요.</ListItemSecondaryAction>
        </ListItem>

        <ListItem>
          <Link to="/pay?basket=402880828b0fce5b018b0fcebef80000" variant="4">
            {"POST 결제 방식 테스트"}
          </Link>
          <ListItemText></ListItemText>
          <ListItemSecondaryAction>
            {"POST 방식 결제방식으로 결제합니다."}
          </ListItemSecondaryAction>
        </ListItem>
        <ListItem>
          <Link to="/pays?basket=402880828b0fce5b018b0fcebef80000" variant="5">
            {"GET 결제 방식 테스트"}
          </Link>
          <ListItemText></ListItemText>
          <ListItemSecondaryAction>
            {"get 방식 결제방식으로 결제합니다."}
          </ListItemSecondaryAction>
        </ListItem>

        <ListItem>
          <Link to="/api/all" variant="5">
            사용자 리스트
          </Link>
          <ListItemText></ListItemText>
          <ListItemSecondaryAction>
            사용자 리스트 페이지 입니다.
          </ListItemSecondaryAction>
        </ListItem>
        <ListItem>
          <Link to="/api/item" variant="5">
            사용자의 전체 글 리스트
          </Link>
          <ListItemText></ListItemText>
          <ListItemSecondaryAction>
            TOdo 전체 리스트 페이지 입니다.
          </ListItemSecondaryAction>
        </ListItem>
      </List>
    </Paper>
  );

  if (loading == 0) {
    menu = <div>loading...</div>;
  } else {
  }

  let content;
  /* 로딩중이 아닐 때 렌더링 할 부분 */
  let framePage = (
    <div>
      {navigationBar} {/* 네비게이션 바 렌더링 */}
      <Container maxWidth="md">{""}</Container>
      <Container maxWidth="md">{menu}</Container>
    </div>
  );

  content = framePage;
  return <div className="App">{content}</div>;
}
